import Request from './authorized-request';
import Axios from 'axios';

let cancelToken = null;

export default class AssistantsApi {
  static async fetch(options) {
    if (cancelToken) {
      cancelToken.cancel();
      cancelToken = null;
    }

    cancelToken = Axios.CancelToken.source();

    return Request.get('/plus', {
      params: {
        ...options,
      },
      cancelToken: cancelToken.token,
    });
  }

  static async bulkCreate(data) {
    return Request.post('/plus/bulk', data);
  }

  static async export() {
    return Request.post('/plus/export', null, { responseType: 'blob' });
  }

  static async delete(code) {
    return Request.delete('/plus/' + code);
  }
}
